import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param schemaId string
 * @param organisationId string
 * @return {Promise<any>|Promise}
 */
export default (function (schemaId, organisationId) {
    var url = applyPathVariables(EndPoints.SERVICE_SCHEMA, {
        schemaId: schemaId,
        organisationId: organisationId
    });
    var request = new Request({ method: Methods.DELETE, url: url, withCredentials: true });
    return request.execute();
});
